<template>
    <div id="repertoryManage">
        <div class="title-top bg-f title-tabs">
            <span>仓库管理</span>
            <div class="fr">
                <el-button class="fr" @click="addRepertory">添加新仓库</el-button>
            </div>
        </div>
        <div class="bg-f mt-5 pb-50 pt-30">
            <el-table v-loading="Loading" :data="tableData" tooltip-effect="dark" class="ml-30 mr-30 mt-20 table-default" stripe>
                <el-table-column prop="companyNo" label="销售组织号" min-width="100">
                </el-table-column>
                <el-table-column prop="no" label="仓库编码" min-width="60">
                </el-table-column>
                <el-table-column prop="name" label="仓库名称" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isMain" class="main-logo">主</span>{{scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column prop="linkman" label="负责人" min-width="100">
                </el-table-column>
                <el-table-column prop="useLogistics" label="是否经过物流" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.useLogistics ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="仓库地址" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.provinceName}}
                        {{scope.row.cityName}}
                        {{scope.row.regionName}}
                        {{scope.row.streetName}}
                        {{scope.row.attr}}
                    </template>
                </el-table-column>
                  <el-table-column label="仓库共享" min-width="200">
                    <template slot-scope="{row}">
                        {{row.shared?'是':'否'}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="190">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="editRepertory(row)" >编辑</el-button>
                        <el-button type="text" @click="deleteRepertory(row.id)" v-if="!(row.isMainCompany && row.isMain)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <!-- 添加新仓库弹窗-->
        <el-dialog :close-on-click-modal="false"  :title="stockTitle + '仓库'" :visible.sync="addRepertoryDialog" @close="closeDialog" width="730px">
            <div>
                <el-form :model="addRepertoryForm"  :rules="rules" ref="addRepertoryFormRef" label-width='185px' class="pb-20">
                    <el-form-item label="销售组织号:" prop="companyNo">
                        <!-- :disabled="forbidEdit" -->
                        <el-input type="number" v-model.trim ="addRepertoryForm.companyNo"  :max="9999999999" disabled placeholder="请输入销售组织号"></el-input>
                    </el-form-item>
                    <el-form-item label="仓库名称:" prop="name">
                        <el-input v-model.trim ="addRepertoryForm.name" :maxlength="10"  placeholder="请输入仓库名称"></el-input>
                        <el-checkbox v-model="addRepertoryForm.isMain" :disabled="forbidEdit">主仓库</el-checkbox>
                    </el-form-item>
                    <el-form-item label="仓库编码:" prop="no">
                        <el-input v-model.trim ="addRepertoryForm.no" :maxlength="10" :disabled="noForbidEdit" placeholder="请输入仓库编码"></el-input>

                    </el-form-item>
                    <el-form-item label="是否经过物流" required>
                        <el-radio-group v-model="addRepertoryForm.useLogistics">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="仓库地址:" prop="districtIds">
                        <selectArea v-model="districtIds" @changeName="changeName" />
                    </el-form-item>
                    <el-form-item label="详细地址:" prop="attr" class="clearfix">
                        <el-input v-model.trim="addRepertoryForm.attr" :maxlength="40" placeholder="请填写详细地址" ></el-input>
                    </el-form-item>
                    <el-form-item label="负责人:">
                        <el-input v-model.trim="addRepertoryForm.linkman" :maxlength="10" placeholder="请输入负责人"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" prop="tel">
                        <el-input v-model.trim="addRepertoryForm.tel" :maxlength="12" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button :loading="btnLoading" type="primary" @click="addRepertoryClick">确定</el-button>
                <el-button  @click="addRepertoryDialog=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getWarehouseList, insertWarehouseInfo, updateWarehouseInfo, deleteWarehouseInfo, } from "@/api/warehouse";
    import { getTraderInfoBySerllerId } from "@/api/publicInfo";
    export default {
        name: "repertoryManage",
        data(){
            var validateAddress = (rule, value, callback) => {
                var info = this.districtIds
                if (info.length===0) {
                    callback(new Error('请选择省市区'));
                } else {
                    if(info[0]==null){
                    callback(new Error('请选择省'));
                    }else if(info[1]===null){
                    callback(new Error('请选择市'));
                    }else if(info[2]===null){
                    callback(new Error('请选择区'));
                    }else{
                    callback();
                    }
                }
            };
            return{
                forbidEdit: false,//部分仓库的组织号仓库名等禁止编辑
                noForbidEdit: false,// 编辑时，有仓库编码，不可编辑仓库编码
                stockTitle: '',
                tableData:[],
                Loading: false,
                btnLoading: false,
                addRepertoryDialog: false,
           
               
                addRepertoryForm:{
                    id:null,
                    name: null,
                    provinceId:null,
                    cityId:null,
                    regionId:null,
                    streetId:null,
                    provinceName: null,
                    cityName: null,
                    regionName: null,
                    streetName:null,
                    attr: null,
                    companyNo:null,
                    no:null,
                    isMain:false,
                    useLogistics :false,
                    linkman:null,
                    tel:null,
                },
                districtIds:[], // 地址ID数组
                areaNameList: [], // 地址名称
                rules:{
                    companyNo: [
                        { required: true, message: '请填写销售组织号', trigger: 'blur' },
                        {min: 1, max: 10, message: '请正确填写销售组织号,1到10位数字', trigger: 'blur'}
                    ],
                    name: [
                        { required: true, message: '请输入仓库名称', trigger: 'blur' },
                        { min: 1, max: 10, message: '请正确填写，仓库名称1-10个字符', trigger: 'blur' }
                    ],
                    no: [
                        { required: true, message: '请填写仓库编号', trigger: 'blur' },
                        {min: 1, max: 10, message: '请正确填写销售组织号', trigger: 'blur'},
                        {pattern: /^[a-zA-Z0-9]{1,10}$/, message: '请正确填写销售组织号', trigger: 'blur'},
                    ],
                    districtIds: [
                        { validator: validateAddress, trigger: 'change' },
                    ],
                    // attr: [
                    //     { required: true, message: '请正确填写地址，2-60个字符', trigger: 'blur' },
                    //     { min: 2, max: 60, message: '请正确填写地址，2-60个字符', trigger: 'blur' }
                    // ],
                    // streetId: [{
                    //     validator: streetId
                    // }],
                    dispatchingId: [
                        {type: 'array', required: true, message: '请选择地区', trigger: 'blur'}
                    ],
                    k3WarehouseCompanyNo: [
                        { required: true, message: '请选择k3仓库', trigger: 'blur'}
                    ],
                    linkman: [
                        { min: 2, max: 20, message: '请正确填写，2-20个字符', trigger: 'blur'}
                    ],
                    tel: [
                        { pattern: /^[0-9]{7,12}$/, message: '请正确填写电话号码7-12位数字', trigger: 'blur'}
                    ]
                },
            }
        },
        mounted(){
            this.getList()
        },
        activated(){
            this.getList()
        },
        methods:{
            getList() {
                getWarehouseList({traderId: sessionStorage.getItem("traderId")}).then(res=>{
                    this.tableData = res ? res : []
                }).catch(err=>{

                })
            },
            insertInfo(){
                insertWarehouseInfo(this.addRepertoryForm).then(res=>{
                    this.addRepertoryDialog = false;
                    this.btnLoading = false
                    this.$message.success('新增成功！')
                    this.getList()
                }).catch(err=>{
                    this.btnLoading = false
                })
            },
            updateInfo(){
                updateWarehouseInfo(this.addRepertoryForm).then(res=>{
                    this.addRepertoryDialog = false;
                    this.btnLoading = false
                    this.$message.success('编辑成功！')
                    this.getList()
                }).catch(err=>{
                    this.btnLoading = false
                })
            },
            deleteInfo(id){
                deleteWarehouseInfo({id}).then(res=>{
                    this.$message.success('删除成功')
                    this.getList()
                }).catch(err=>{

                })
            },

            
            changeName(e){
			    this.areaNameList = e
                

                
		    },
            resetForm() { //清空验证方法
                this.$refs['addRepertoryFormRef'].resetFields();
            },
            closeDialog(done) {
                this.addRepertoryForm = {
                    id:null,
                    name: null,
                    provinceId:null,
                    cityId:null,
                    regionId:null,
                    streetId:null,
                    provinceName: null,
                    cityName: null,
                    regionName: null,
                    streetName:null,
                    attr: null,
                    companyNo:null,
                    no:null,
                    isMain:false,
                    useLogistics :false,
                    linkman:null,
                    tel:null,
                }
                this.districtIds=[]// 地址ID数组
                this.areaNameList=[] // 地址名称
                this.resetForm()
            },

            addRepertory() {
                this.stockTitle = '新增'
                this.forbidEdit = false
                this.noForbidEdit = false
                this.addRepertoryDialog = true
                getTraderInfoBySerllerId({traderId:sessionStorage.traderId}).then(res=>{
                    this.addRepertoryForm.companyNo = res.k3SalesCompanyNo
                }).catch(err=>{})
            },


            addRepertoryClick() {
                this.addRepertoryForm.provinceId=this.districtIds[0];
                this.addRepertoryForm.cityId= this.districtIds[1];
                this.addRepertoryForm.regionId= this.districtIds[2];
                this.addRepertoryForm.streetId= this.districtIds[3];
                this.addRepertoryForm.provinceName=this.areaNameList[0];
                this.addRepertoryForm.cityName= this.areaNameList[1];
                this.addRepertoryForm.regionName= this.areaNameList[2];
                this.addRepertoryForm.streetName= this.areaNameList[3];

                this.$refs.addRepertoryFormRef.validate(valid => {
                    if(valid) {
                        this.btnLoading = true
                        if(this.addRepertoryForm.id){
                            // 编辑
                            this.updateInfo()
                        }else{
                            // 新增
                            this.insertInfo()
                        }
                    }
                })
            },
            editRepertory(val) {
                    const data = val
                    if (data.isMain){
                        this.forbidEdit = true
                    }else{
                        this.forbidEdit = false
                    }
                    if (data.no){
                        this.noForbidEdit = true
                    }else{
                        this.noForbidEdit = false
                    }
                    const districtIds = [].concat(data.provinceId ? data.provinceId.toString() : null ,data.cityId ? data.cityId.toString() : null ,data.regionId ? data.regionId.toString() : null,data.streetId ? data.streetId.toString() : null)
                    this.districtIds=districtIds;
                    this.addRepertoryForm = {
                        id: data.id,
                        name: data.name,
                        attr: data.attr,
                        companyNo:data.companyNo,
                        no:data.no,
                        isMain:data.isMain,
                        useLogistics:data.useLogistics,
                        linkman: data.linkman,
                        tel: data.tel,
                       
                    }                 
                    this.addRepertoryDialog = true;
                    this.stockTitle = '编辑';
            },
            deleteRepertory(id){
                this.$confirm('确定要删除该仓库？', '删除仓库', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteInfo(id)
                   
                }).catch(() => {

                });
            },
        },

    }
</script>

<style lang="less">
#repertoryManage{
    .fr{
        float: right;
    }
    .el-dialog{
        width: 720px;
    }
    .main-logo{
        background-color: red;
        border-radius: 3px;
        padding:2px 3px;
        margin-right: 3px;
        color:#FFF;
    }
}
</style>
